import { render, staticRenderFns } from "./editContent.1.vue?vue&type=template&id=48ea7f10&scoped=true&"
import script from "./editContent.1.vue?vue&type=script&lang=js&"
export * from "./editContent.1.vue?vue&type=script&lang=js&"
import style0 from "./editContent.1.vue?vue&type=style&index=0&id=48ea7f10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ea7f10",
  null
  
)

export default component.exports